import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export function Field({ label, hint, error, required, className, children, ...rest }) {
    const classes = ['kb-field', className].filter(Boolean).join(' ');
    return (_jsxs("div", { className: classes, ...rest, children: [_jsxs("label", { className: "kb-field__label", children: [label, required && (_jsxs("span", { className: "kb-field__required", "aria-hidden": "true", children: [' ', "*"] }))] }), children, error ? (_jsx("p", { className: "kb-field__error", role: "alert", children: error })) : hint ? (_jsx("p", { className: "kb-field__hint", children: hint })) : null] }));
}
export function Input({ className, invalid, ...rest }) {
    const classes = ['kb-input', invalid && 'kb-input--invalid', className].filter(Boolean).join(' ');
    return _jsx("input", { className: classes, ...rest });
}
export function Select({ className, invalid, children, ...rest }) {
    const classes = ['kb-input', 'kb-input--select', invalid && 'kb-input--invalid', className]
        .filter(Boolean)
        .join(' ');
    return (_jsx("select", { className: classes, ...rest, children: children }));
}
export function Textarea({ className, invalid, ...rest }) {
    const classes = ['kb-input', 'kb-input--textarea', invalid && 'kb-input--invalid', className]
        .filter(Boolean)
        .join(' ');
    return _jsx("textarea", { className: classes, ...rest });
}
//# sourceMappingURL=Field.js.map